import {
  MenuItem,
  TextField,
} from '@mui/material';

import type { IntegrationField } from '../../api/integrations.api';

/**
 * The select used for settings with a fixed set of values, e.g. the
 * commission-transfer mode (DEV-127). Switching to LIVE asks for a reason in
 * the shared save bar (SettingsSaveBar, DEV-133).
 */

interface SelectFieldProps {
  field: IntegrationField;
  vendorId: string;
  value: string | undefined;
  onChange: (value: string) => void;
  /** Shown, not changed (DEV-140). */
  readOnly?: boolean;
}

/** A setting with a fixed set of values, e.g. the commission transfer mode. */
export function SelectSettingField({ field, vendorId, value, onChange, readOnly = false }: SelectFieldProps): JSX.Element {
  const current = value ?? String(field.value ?? field.placeholder ?? '');
  return (
    <TextField
      select
      fullWidth
      label={`${field.label}${field.required ? '' : ' (optional)'}`}
      value={current}
      onChange={(event) => onChange(event.target.value)}
      helperText={field.help}
      InputLabelProps={{ shrink: true }}
      SelectProps={{ readOnly }}
      // Unusual name so Chrome's autofill heuristics leave it alone.
      inputProps={{ name: `nvx-${vendorId.toLowerCase()}-${field.key}`, autoComplete: 'new-password' }}
    >
      {(field.options ?? []).map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
}
